import { List } from 'immutable';

/**
 * The cards a Pokémon in play evolved from, oldest first: its devolve attachments' cards (kept under it, so Devolution
 * Spray can bring them back), in the order they were put down.
 */
export const evolvedFrom = (pokemon) => (pokemon.get('devolveAttachments') || List())
  .sortBy(attachment => attachment.get('id'))
  .map(attachment => attachment.get('card'))
  .filter(card => !!card);
